import { useSelector } from 'react-redux';
import { RUBRIQ_PLAN_NAMES_MAP } from 'rubriq/constants';

/**
 * Returns the common tracking properties required on every Abstract Mixpanel event.
 *
 * @returns {{ userIdentity: string|null, planType: string|null, planName: string|null, trialStatus: string }}
 */
var useAbstractTrackingProps = function useAbstractTrackingProps() {
  var _premium$type, _premium$planName, _user$identity;
  var user = useSelector(function (state) {
    return state.user || {};
  });
  var premium = useSelector(function (state) {
    var _state$curie;
    return (_state$curie = state.curie) === null || _state$curie === void 0 || (_state$curie = _state$curie.plans) === null || _state$curie === void 0 ? void 0 : _state$curie.premium;
  });
  var planType = (_premium$type = premium === null || premium === void 0 ? void 0 : premium.type) !== null && _premium$type !== void 0 ? _premium$type : null;
  var rawPlanName = (_premium$planName = premium === null || premium === void 0 ? void 0 : premium.planName) !== null && _premium$planName !== void 0 ? _premium$planName : null;
  var planName = rawPlanName ? RUBRIQ_PLAN_NAMES_MAP[rawPlanName] || rawPlanName : null;
  var trialStatus = (premium === null || premium === void 0 ? void 0 : premium.paymentStatus) === 'trialing' ? 'trialing' : 'none';
  return {
    userIdentity: (_user$identity = user.identity) !== null && _user$identity !== void 0 ? _user$identity : null,
    planType: planType,
    planName: planName,
    trialStatus: trialStatus
  };
};
export default useAbstractTrackingProps;